import ACTIONS from "../actions/types";

const initialState = {
  allOwnersList: [],
  deviceInstallData: {},
  allTechniciansList: [],
  installationOrdersList: [],
  installationOrdersTotal: 0,
  selectedDeviceToInstall: {},
  isFetchingTechniciansList: true,
  isCreateNewInstallationOrder: false,
  selectedInstallationOrderDetails: {},
  selectedInstallationOrderDevices: [],
  isFetchinginstallationOrdersList: false,
  isFetchingSelectedDeviceToInstall: true,
  isFetchinginstallationOrderDevices: true,
  isFetchinginstallationOrderDetails: false,
  selectedDeviceToInstallAttachmentsList: [],
  isInstallingDevice: false,
  installingDeviceMessage: "uploadingDeviceImagesSucceeded",
  wizardActiveStep: localStorage.getItem("wizardActiveStep") ? localStorage.getItem("wizardActiveStep") : "information",
};

const installationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER_START:
      return {
        ...state,
        isCreateNewInstallationOrder: true,
      };
    case ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER:
      return {
        ...state,
        installationOrdersList: [...state.installationOrdersList, payload],
        selectedInstallationOrderDetails: { ...payload },
        isCreateNewInstallationOrder: false,
      };
    case ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER_FAILURE:
      return {
        ...state,
        isCreateNewInstallationOrder: false,
      };

    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_START:
      return {
        ...state,
        isFetchinginstallationOrdersList: true,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER:
      return {
        ...state,
        installationOrdersList: [...payload.data],
        installationOrdersTotal: payload.total,
        isFetchinginstallationOrdersList: false,
      };
    case ACTIONS.INSTALLATION.ARCHIVE_INSTALLATION_ORDER:
      // Instead of swapping, we will filter out the archived order
      const updatedInstallationOrdersList = state.installationOrdersList.filter((order) => order._id !== payload._id);
      return {
        ...state,
        installationOrdersList: updatedInstallationOrdersList,
        isFetchinginstallationOrdersList: false,
      };
    case ACTIONS.INSTALLATION.DELETE_INSTALLATION_ORDER:
      // Instead of swapping, we will filter out the archived order
      const updatedDeletedList = state.installationOrdersList.filter((order) => order._id !== payload._id);
      return {
        ...state,
        installationOrdersList: updatedDeletedList,
        isFetchinginstallationOrdersList: false,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_FAILURE:
      return {
        ...state,
        isFetchinginstallationOrdersList: false,
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS_START:
      return {
        ...state,
        selectedInstallationOrderDetails: {},
        isFetchinginstallationOrderDetails: true,
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS:
      return {
        ...state,
        isFetchinginstallationOrderDetails: false,
        selectedInstallationOrderDetails: { ...payload },
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS_FAILURE:
      return {
        ...state,
        isFetchinginstallationOrderDetails: false,
        selectedInstallationOrderDetails: {},
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES_START:
      return {
        ...state,
        isFetchinginstallationOrderDevices: true,
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES:
      return {
        ...state,
        isFetchinginstallationOrderDevices: false,
        selectedInstallationOrderDevices: [...payload],
      };
    case ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES_FAILURE:
      return {
        ...state,
        isFetchinginstallationOrderDevices: false,
        selectedInstallationOrderDevices: [],
      };
    case ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE_START:
      return {
        ...state,
        isFetchinginstallationOrderDevices: true,
        // selectedInstallationOrderDevices:[]
      };
    case ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE:
      return {
        ...state,
        isFetchinginstallationOrderDevices: false,
        selectedInstallationOrderDevices: state.selectedInstallationOrderDevices.map((d) =>
          d._id === payload._id
            ? {
                ...payload,
              }
            : { ...d }
        ),
      };
    case ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE_FAILURE:
      return {
        ...state,
        isFetchinginstallationOrderDevices: false,
        // selectedInstallationOrderDevices:[]
      };
    case ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE_START:
      return {
        ...state,
        isFetchinginstallationOrderDetails: true,
      };
    case ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE:
      return {
        ...state,
        isFetchinginstallationOrderDetails: false,
        selectedInstallationOrderDetails: { ...payload },
      };
    case ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE_FAILURE:
      return {
        ...state,
        isFetchinginstallationOrderDetails: false,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER_START:
      return {
        ...state,
        allOwnersList: [],
        isFetchingOwnersList: true,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER:
      return {
        ...state,
        allOwnersList: [...payload],
        isFetchingOwnersList: false,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER_FAILURE:
      return {
        ...state,
        allOwnersList: [],
        isFetchingOwnersList: false,
      };

    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS_START:
      return {
        ...state,
        allTechniciansList: [],
        isFetchingTechniciansList: true,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS:
      return {
        ...state,
        allTechniciansList: [...payload],
        isFetchingTechniciansList: false,
      };
    case ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS_FAILURE:
      return {
        ...state,
        allTechniciansList: [],
        isFetchingTechniciansList: false,
      };

    case ACTIONS.INSTALLATION.SET_SELECTED_DEVICE_TO_INSTALL:
      return {
        ...state,
        deviceInstallData: payload.deviceData,
        selectedDeviceToInstall: payload.deviceData,
        isFetchingSelectedDeviceToInstall: false,
        selectedDeviceToInstallAttachmentsList: payload.deviceAttachments,
      };

    case ACTIONS.INSTALLATION.SET_SELECTED_DEVICE_TO_INSTALL_START:
      localStorage.setItem("wizardActiveStep", "information"); //Default should be information
      return {
        ...state,
        deviceInstallData: {},
        selectedDeviceToInstall: {},
        isFetchingSelectedDeviceToInstall: true,
        selectedDeviceToInstallAttachmentsList: [],
        wizardActiveStep: "information", //Default should be information
      };

    case ACTIONS.INSTALLATION.SET_WIZARD_ACTIVE_STEP:
      localStorage.setItem("wizardActiveStep", payload);
      return {
        ...state,
        wizardActiveStep: payload,
      };

    case ACTIONS.INSTALLATION.SET_DEVICE_INSTALL_DATA:
      return {
        ...state,
        deviceInstallData: { ...payload },
      };

    case ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE_START:
      return {
        ...state,
        isInstallingDevice: true,
        installingDeviceMessage: "installingDevice",
      };
    case ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE:
      return {
        ...state,
        isInstallingDevice: false,
        installingDeviceMessage: "installingDeviceSucceeded",
      };
    case ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE_FAILURE:
      return {
        ...state,
        isInstallingDevice: false,
        installingDeviceMessage: "installingDeviceFailed",
      };
    case ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION_START:
      return {
        ...state,
        isInstallingDevice: true,
        installingDeviceMessage: "uploadingDeviceImages",
      };
    case ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION:
      return {
        ...state,
        isInstallingDevice: false,
        installingDeviceMessage: "uploadingDeviceImagesSucceeded",
      };
    case ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION_FAILURE:
      return {
        ...state,
        isInstallingDevice: false,
        installingDeviceMessage: "uploadingDeviceImagesFailed",
      };
    default:
      return { ...state };
  }
};
export default installationReducer;
